import { Attribute } from '@app/gen/events';

type MultipleDocumentTextAttribute = Attribute & { value: string[] };

export const isMultipleDocumentTextAttribute = (
  attribute: Attribute,
): attribute is MultipleDocumentTextAttribute =>
  attribute.type !== 'file' && attribute.type !== 'file_multiple';
